<template>
  <div class="product-info ">
    <div class="product-info-header">
      <div class="product-info-header-title">产品详情</div>

    </div>
    <div class="product-info-content">
      <div style="margin: 15px 0;">
        <span style="cursor: pointer;" @click="close">详情中心&ensp;/&ensp; </span> <span
          style="color: rgba(32, 129, 235, 1);">详情页</span>
      </div>
      <div class="product-info-content-html" v-if="_html" v-html="_html"></div>


    </div>
    <div class="product-info-footer">
      <a-button class="learnmore-btn" type="primary" @click="close">返回列表</a-button>
    </div>
    <FloatActionButtonmobile :right="20" :bottom="20" icon="logoIcon-weui-contacts-filled"
      @handelClick="handleFabClick" />
    <div v-if="showMask" class="wechat-share-mask" @click="hideMask">
      <div class="share-guide">
        <div class="arrow"></div>
        <div class="share-guide-text">点击「...」分享给好友</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { getFilterList, getRowById } from "@/api/index"
import { useWxShare } from "@/utils/wxshare"
import { useRouter, useRoute } from 'vue-router'
import FloatActionButtonmobile from '@/components/FloatActionButtonmobile.vue';
import useClipboard from 'vue-clipboard3';
import { message } from 'ant-design-vue';
const props = defineProps({
  itemInfo: {
    type: Object,
    default: () => ({})
  },
  list: {
    type: Array,
    default: () => []
  }
})
const { toClipboard } = useClipboard();
const emit = defineEmits(['changeItem', "close"])
const dataInfo = ref([])
const itemInfo = computed(() => props.itemInfo)
const list = computed(() => props.list)
const route = useRoute()
const showMask = ref(false);
const imgUrl = computed(() => {
  let url = ""
  if (itemInfo.value["picture-uploadc8da899c"] && itemInfo.value["picture-uploadc8da899c"].length > 0) {
    url = itemInfo.value["picture-uploadc8da899c"][0].url
  }
  return url
})
const _html = computed(() => {
  return itemInfo.value["rich-editor20df22ce"] || ""
})

// const getData = async () => {
//  console.log(itemInfo.value);

//  if (itemInfo.value && itemInfo.value.rowId) {
//   let params = {
//    page: 1,
//    pageSize: 1000,
//    filters: [
//     {
//      "dataType": 65,
//      "field": "associationFields0d56121d",
//      "spliceType": 0,
//      "values": [
//       itemInfo.value.rowId
//      ],
//      "isDynamicSource": false,
//      "dynamicSource": [],
//      "filterType": 2
//     }

//    ],
//    worksheetId: "680f499f88d915058691fbd6",
//   }
//   const res = await getFilterList(params)
//   if (res.code === 200) {
//    dataInfo.value = res.data
//   }
//  }
// }

// watch(() => itemInfo.value, (newVal) => {
//  getData()
// }, { deep: true })

const prev = computed(() => {
  return list.value[list.value.findIndex(item => item.rowId === itemInfo.value.rowId) - 1]
})
const next = computed(() => {
  return list.value[list.value.findIndex(item => item.rowId === itemInfo.value.rowId) + 1]
})

const nextData = async () => {
  if (next.value) {
    // getFilter(next.value)
    emit("changeItem", next.value)
  }
}
const prevData = async () => {
  if (prev.value) {
    // getFilter(prev.value)
    emit("changeItem", prev.value)
  }
}

const close = () => {
  emit("close")
}
const isWeChatBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /micromessenger/.test(ua); // 微信的标识是 'micromessenger'
}
const url = computed(() => {
  return `${location.origin}#${route.fullPath}`
})


const handleFabClick = async () => {
  if (isWeChatBrowser()) {
    showMask.value = true
    console.log("当前是微信浏览器");
  } else {
    try {
      await toClipboard(url.value);
      message.success('链接复制成功');
    } catch (e) {
      message.error(`复制失败: ${e}`);
    }
  }
}
const hideMask = () => {
  showMask.value = false;
  // 可以在这里设置本地存储，记录已经显示过
  // localStorage.setItem('hasShownWeChatShare', 'true');
};

onMounted(() => {
  let img = `${location.origin}${imgUrl.value}`
  useWxShare(itemInfo.value.input988275a1, itemInfo.value.inputde060c84, url.value, img)
})

</script>

<style scoped lang="less">
.product-info {
  font-family: 'PuHuiTi';
  width: 100%;
  height: 100%;
  position: relative;
}

.product-info-header {
  width: 100%;
  height: 300px;
  background: url("../../../assets/image/product/itemInfo_bg_mobile.png") no-repeat;
  background-size: cover;
  display: flex;
  // align-items: center;
  justify-content: center;
  position: absolute;
}

.product-info-header-title {
  color: rgba(51, 51, 51, 1);
  font-weight: 500;
  font-size: 32px;
  font-family: 'PuHuiTi';
  padding-left: 18%;
  padding-right: 18%;
  padding-top: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

}

.product-info-content {
  width: 100%;
  height: 100%;
  padding: 0 30px;

  padding-top: 200px;
  z-index: 99;
}

.product-info-content-img-bg {

  background: url("../../../assets/image/product/info_bg.png") no-repeat;
  background-size: 100% 100%;
  padding: 30px;
  margin: 30px 0;
}

.product-info-content-title {
  font-size: 22px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);

  background: url("../../../assets/image/product/Line.png") no-repeat;
  background-position: 0% 100%;

}

.product-info-content-jianjie {
  font-size: 14px;
  margin-top: 20px;
  color: rgba(51, 51, 51, 1);
}

.product-info-footer {
  width: 100%;
  display: flex;
  margin-bottom: 30px;
  justify-content: center;
}

.learnmore-btn {

  width: 210px;
  height: 46px;
  margin-right: 1%;
  border-radius: 10px;
}

.product-info-content-page {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}

.product-info-content-page-button {
  width: 45%;
  height: 46px;
  background: rgba(248, 250, 250, 1);
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-left: 10px;
}

.product-info-content-page-button-text {
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-info-content-page-button-text-right {
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
}

.product-info-content-page-button-right {
  width: 45%;
  height: 46px;
  background: rgba(248, 250, 250, 1);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  padding-right: 10px;
}

.product-info-content-html {
  min-height: 519px;
}

::v-deep(.product-info-content-html img) {
  max-width: 100%;
  height: auto !important;
}

.wechat-share-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 20px;
}

.share-guide {
  position: relative;
  background-color: #fff;
  padding: 0 10px;
  border-radius: 8px;
  color: #333;
  font-size: 14px;

  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.share-guide-text {
  display: flex;
  align-items: center;
  display: block;
}

.arrow {
  position: absolute;
  top: -10px;
  right: 5px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 10px solid #fff;
}

/* 动画效果 */
.wechat-share-mask {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>